import { type DocumentNode, gql } from '@apollo/client';

const sessionTimeout: DocumentNode = gql`
  query Session {
    sessionTimeout
  }
`;

export default sessionTimeout;
